<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Carousel</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--carousel-->
                <div class="carousel-container">


                    <div class="row no-margin">

                        <!-- carousel 1 -->
                        <div class="col-6 paddingleft0">
                            <div class="carousel-block without-bottom-navigation">
                                <div id="carousel1" class="carousel slide" data-ride="carousel">
                                    <!-- Indicators -->
                                    <ul class="carousel-indicators">
                                        <li data-target="#carousel1" data-slide-to="0" class="active"></li>
                                        <li data-target="#carousel1" data-slide-to="1"></li>
                                        <li data-target="#carousel1" data-slide-to="2"></li>
                                    </ul>
                                    <!-- The slideshow -->
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img src="/static/images/carousal_img.jpg">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="/static/images/carousal_img.jpg">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="/static/images/carousal_img.jpg">
                                        </div>
                                    </div>
                                    <!-- Left and right controls -->
                                    <a class="carousel-control-prev" href="#carousel1" data-slide="prev">
                                        <span class="carousel-control-prev-icon"></span>
                                    </a>
                                    <a class="carousel-control-next" href="#carousel1" data-slide="next">
                                        <span class="carousel-control-next-icon"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- carousel 1 -->


                        <!-- carousel 2 -->
                        <div class="col-6 paddingright0">
                            <div class="carousel-block without-middle-navigation">
                                <div id="carousel2" class="carousel slide" data-ride="carousel">
                                    <!-- Indicators -->
                                    <ul class="carousel-indicators">
                                        <li data-target="#carousel2" data-slide-to="0" class="active"></li>
                                        <li data-target="#carousel2" data-slide-to="1"></li>
                                        <li data-target="#carousel2" data-slide-to="2"></li>
                                    </ul>
                                    <!-- The slideshow -->
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img src="/static/images/carousal_img.jpg">
                                            <div class="carousel-caption">
                                                <h3>Title goes here</h3>
                                                <p>We had such a great time in LA!</p>
                                            </div>   
                                        </div>
                                        <div class="carousel-item">
                                            <img src="/static/images/carousal_img.jpg">
                                            <div class="carousel-caption">
                                                <h3>Title goes here</h3>
                                                <p>We had such a great time in LA!</p>
                                            </div>  
                                        </div>
                                        <div class="carousel-item">
                                            <img src="/static/images/carousal_img.jpg">
                                            <div class="carousel-caption">
                                                <h3>Title goes here</h3>
                                                <p>We had such a great time in LA!</p>
                                            </div>  
                                        </div>
                                    </div>
                                    <!-- Left and right controls -->
                                    <a class="carousel-control-prev" href="#carousel2" data-slide="prev">
                                        <span class="carousel-control-prev-icon"></span>
                                    </a>
                                    <a class="carousel-control-next" href="#carousel2" data-slide="next">
                                        <span class="carousel-control-next-icon"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- carousel 2 -->

                        <!--height space-->
                        <div class="height30"></div>
                        <!--height space-->

                        <!-- carousel 3 -->
                        <div class="col-6 paddingleft0">
                            <div class="carousel-block without-middle-navigation">
                                <div id="carousel3" class="carousel slide" data-ride="carousel">
                                    <!-- Indicators -->
                                    <ul class="carousel-indicators">
                                        <li data-target="#carousel3" data-slide-to="0" class="active"></li>
                                        <li data-target="#carousel3" data-slide-to="1"></li>
                                        <li data-target="#carousel3" data-slide-to="2"></li>
                                    </ul>
                                    <!-- The slideshow -->
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img src="/static/images/carousal_img.jpg">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="/static/images/carousal_img.jpg">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="/static/images/carousal_img.jpg">
                                        </div>
                                    </div>
                                    <!-- Left and right controls -->
                                    <a class="carousel-control-prev" href="#carousel3" data-slide="prev">
                                        <span class="carousel-control-prev-icon"></span>
                                    </a>
                                    <a class="carousel-control-next" href="#carousel3" data-slide="next">
                                        <span class="carousel-control-next-icon"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- carousel 3 -->
                    </div>
                </div>
                <!--carousel-->


            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/carousal.vue